import type {
  AgentGetFiatTransactionHistoryInput,
  AgentCalculateWithdrawalCostInput,
} from '../api'
import userAgentPaymentService from './agent-payment.service'
import { EAgentPaymentQueryKey } from './agent-payment.types'

export const calculateAgentWithdrawalCostOptions = (
  filter: AgentCalculateWithdrawalCostInput,
) => {
  return {
    queryKey: [EAgentPaymentQueryKey.CALCULATE_WITHDRAWAL_COST, filter],
    queryFn: () => userAgentPaymentService.calculateAgentWithdrawalCost(filter),
  }
}

export const getAgentFiatTransactionHistoryOptions = (
  params: AgentGetFiatTransactionHistoryInput,
) => {
  return {
    queryKey: [EAgentPaymentQueryKey.GET_FIAT_TRANSACTION_HISTORY, params],

    queryFn: ({ pageParam = 0 }) =>
      userAgentPaymentService.getAgentFiatTransactionHistory({
        ...params,
        skip: pageParam * (params.limit || 10),
      }),
    staleTime: 1,
    getNextPageParam: (lastPage: any, allPages: any) => {
      const total = lastPage.data?.total || 0
      const messages = lastPage.data?.transactions || []
      const limit = params.limit || 10

      // If we have total count, use it for pagination
      if (total !== undefined && total !== null) {
        const currentLength = allPages.reduce(
          (acc: number, page: any) =>
            acc + (page.data?.transactions?.length || 0),
          0,
        )
        return currentLength < total ? allPages.length : undefined
      }

      // Fallback: If no total, check if we got fewer messages than requested
      // This indicates we've reached the end
      if (messages.length < limit) {
        return undefined
      }

      // If we got exactly the limit, there might be more data
      return allPages.length
    },
    initialPageParam: 0,
  }
}
